const { curry2 } = require('../../fp');

/**
 * Removes entries from a storage based on a predicate function.
 *
 * Supports partial application:
 *   purgeStorage(predicate, storage)
 *   purgeStorage(predicate)(storage)
 *
 * @param {Function} shouldPurgeItem
 * Predicate function that determines whether a storage entry should be removed.
 * It is called with an object containing:
 *   - key   {string} The storage key
 *   - value {any}    The stored value
 * It must return `true` to remove the entry, or `false` to keep it.
 *
 * @param {Storage} storage
 * The storage instance to purge.
 *
 * @returns {Storage}
 * The same storage instance after purge.
 */
const purgeStorage = curry2((shouldPurgeItem, storage) => {
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);

    if (key != null) {
      const value = storage.getItem(key);

      if (shouldPurgeItem({ key, value })) {
        storage.removeItem(key);
        i -= 1;
      }
    }
  }

  return storage;
});

module.exports = purgeStorage;
